import type { NextPage } from "next";
import { Link } from "../components/Actions";
import NextImage from "next/legacy/image";
import { FadeText } from "../components/Animation/FadeText";

import { CutoutAsset } from "../components/CutoutAsset/CutoutAsset";

import pressMobile from "../assets/pressMobile.png";
import pressDesktop from "../assets/pressDesktop.png";
import presskitCover from "../assets/press-kit-cover.png";
import pressRelease from "../assets/press-release.png";

import SEO from "../components/Seo/Seo";

const Press: NextPage = () => {
  return (
    <>
      <SEO title="Press  | Coinage Media" />

      <section className="roadmap-main overflow-hidden">
        <div className="roadmap-header  h-[80vh] tab:h-[66vh] bg-coinage-orange relative overflow-hidden">
          <div className="hidden tab:flex absolute overflow-hidden z-0 right-0  w-2/3  h-full about-image-holder">
            <CutoutAsset image={pressDesktop} right={false} color="orange" />
          </div>

          <div className="tab:hidden absolute bottom-0 overflow-hidden z-0 right-0  w-full h-1/2 about-image-holder">
            <CutoutAsset image={pressMobile} mobile={true} color="orange" />
          </div>
          <div className="flex mt-[60px] tab:mt-auto mb-auto z-1 relative mx-[auto] max-w-[1200px] w-full px-4 h-full">
            <FadeText
              textStyle="display1"
              className="p-4 mt-auto mb-auto flex display1  max-w-[720px] text-coinage-offWhite">
              Press.
            </FadeText>
          </div>
        </div>

        <div className="mt-10 grid mb-[60px] px-2 mx-auto max-w-[720px] w-full tab:grid-cols-2 gap-[30px]">
          <div>
            <div className="overflow-hidden rounded-3xl">
              <NextImage layout="responsive" src={presskitCover} alt="" />
            </div>
            <p className="gtbody">Download</p>
            <h2 className="subhead2 mt-3">
              <Link
                href="/coinage-press-kit.zip"
                analyticsProperty="press 1"
                modifier="secondary">
                Press Kit
              </Link>
            </h2>
          </div>
          <div>
            <div className="overflow-hidden rounded-3xl">
              <NextImage layout="responsive" src={pressRelease} alt="" />
            </div>
            <p className="gtbody">Article</p>
            <h2 className="subhead2 mt-3">
              <Link
                href="https://www.prnewswire.com/news-releases/coinage-releases-exclusive-interview-with-terra-founder-do-kwon--the-man-at-the-center-of-cryptos-largest-collapse-301605460.html"
                target="_blank"
                analyticsProperty="press 1"
                modifier="secondary">
                Press Release, 08/15/22
              </Link>
            </h2>
          </div>
        </div>
      </section>
    </>
  );
};

export default Press;
